var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#479EDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 9.76539L20.3452 21.0365C20.3452 21.0365 20.0191 21.8198 19.1284 21.4446L15.8298 19.0083L13.7162 20.8674C13.7162 20.8674 13.5507 20.9893 13.3706 20.9143L13.7746 17.4574L13.7899 17.469L13.7989 17.3966C13.7989 17.3966 19.7365 12.2559 19.9798 12.0354C20.2231 11.815 20.1404 11.7681 20.1404 11.7681C20.155 11.5007 19.7024 11.7681 19.7024 11.7681L11.8326 16.5851L11.8335 16.5878L11.8281 16.5853L8.55269 15.5205C8.55269 15.5205 8.0514 15.347 8.00273 14.9718C7.95406 14.5965 8.57216 14.3948 8.57216 14.3948L21.6008 9.46989C21.5959 9.46989 22.6667 9.01492 22.6667 9.76539Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bc60bb90a582c69a20939e5a486eb168.svg";
export { ForwardRef as ReactComponent };